// Copyright (c) 2022 by Move Closer

import { CartIdentifier } from '../../../contexts'

import { CartModel } from './models'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface CheckoutState {
  id: CartIdentifier | null
  cart: CartModel | null
  loading: boolean
  registering: boolean
  ssoAuthenticated: boolean
  ssoConsentsRequest: boolean
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum MutationType {
  SetCartId = 'SetCartId',
  SetCart = 'SetCart',
  SetLoading = 'SetLoading',
  SetRegisteringInCheckout = 'SetRegisteringInCheckout',
  SetSSOAuthenticated = 'SetSSOAuthenticated',
  SetSSOConsentsRequest = 'SetSSOConsentsRequest'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const CartMutationTypes: Record<MutationType, string> = {
  [MutationType.SetCartId]: `checkout/${MutationType.SetCartId}`,
  [MutationType.SetCart]: `checkout/${MutationType.SetCart}`,
  [MutationType.SetLoading]: `checkout/${MutationType.SetLoading}`,
  [MutationType.SetRegisteringInCheckout]: `checkout/${MutationType.SetRegisteringInCheckout}`,
  [MutationType.SetSSOAuthenticated]: `checkout/${MutationType.SetSSOAuthenticated}`,
  [MutationType.SetSSOConsentsRequest]: `checkout/${MutationType.SetSSOConsentsRequest}`
}
